export interface CheckoutCompletedRenewalConfirmation {
  planNumber: string;
  coverStartDate: string;
  digitalId?: string;
}
